import { useMediaQuery, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { questionnaireSlice } from '»components/Questionnaire/redux';
import { isDirtyQuestionnaireSelector } from '»components/Questionnaire/redux/questionnaire.selectors';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import { useCurrentPage } from './useCurrentPage';

export function useIsAbleToProceed() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const { isSettingsQuestionnaire, isSettingsMainPage } = useCurrentPage();
  const isDirty = useSelector(isDirtyQuestionnaireSelector);

  const alertMessage = TrlFormattedMessagePlain({
    id: 'TRLT_UI-LEAVE_PAGE_ALERT',
  });

  const isAbleToProceed = (event, navigation) => {
    if (
      (isSettingsQuestionnaire || (!isMobile && isSettingsMainPage)) &&
      isDirty
    ) {
      const confirmLeave = window.confirm(alertMessage);
      if (!confirmLeave) {
        event.preventDefault();
        return;
      }

      navigation();
      dispatch(questionnaireSlice.actions.clearQuestionnaire());
    } else {
      navigation();
    }
  };
  return {
    isAbleToProceed,
  };
}
